var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import { propMatch } from '@/helpers/custom-prop-types';
import { apiGetOneProffitSearchShare } from '../../../../actions/ProffitSearchShareAction';
import { wrapDispatch } from '../../../../helpers/action';
import { AllLoaderComponent } from '../../Loading';
const ProffitSearchShareHistoryHoc = (setting) => (ChildComponent) => {
    const { skeleton } = setting || {};
    const ProffitSearchShareHistoryHocInner = (props) => {
        const { match: { params: { id }, }, } = props;
        const dispatch = useDispatch();
        const share = useSelector((state) => state.proffitSearchShare[id]);
        const [loaded, changeLoaded] = useState({
            [id]: !!share,
        });
        const isLoaded = !!loaded[id];
        useEffect(() => {
            let active = true;
            (() => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    yield wrapDispatch(dispatch, apiGetOneProffitSearchShare(id));
                }
                finally {
                    if (active) {
                        changeLoaded((prev) => (Object.assign(Object.assign({}, prev), { [id]: true })));
                    }
                }
            }))();
            return () => {
                active = false;
            };
        }, [id, dispatch, changeLoaded]);
        if (!isLoaded) {
            return skeleton || _jsx(AllLoaderComponent, {});
        }
        if (!share) {
            return _jsx(CustomRedirect, { to: '/mypage' });
        }
        return _jsx(ChildComponent, Object.assign({}, props, { share: share }));
    };
    ProffitSearchShareHistoryHocInner.propTypes = {
        match: propMatch(),
    };
    return ProffitSearchShareHistoryHocInner;
};
export default ProffitSearchShareHistoryHoc;
